module.exports = __webpack_public_path__ + "img/hero.b87f4e30.png";